export default __webpack_public_path__ + "static/media/29.d8009f77.jpg";